import { render, staticRenderFns } from "./rpo-management.vue?vue&type=template&id=12b69a1b&"
import script from "./rpo-management.vue?vue&type=script&lang=js&"
export * from "./rpo-management.vue?vue&type=script&lang=js&"
import style0 from "./rpo-management.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports